/* this file is transformed by vux-loader */
/* eslint-disable */
// 点击dom外部事件 指令
export default {
  bind: function bind(el, _ref) {
    var value = _ref.value;
    var onClickOutside = value;

    el.handler = function (e) {
      if (el && !el.contains(e.target)) {
        onClickOutside(e);
      }
    };

    document.addEventListener('click', el.handler, true);
  },
  unbind: function unbind(el) {
    document.removeEventListener('click', el.handler, true);
    el.handler = null;
  }
};